// initial state
const state = () => ({
  adminReportsFilters: {},
  adminSummaryReports: {},
  exportData: {},
  graphData: {},
  userAccountCompanyDetails: {},
})

// getters
const getters = {
  getAdminSummaryReports(state) {
    return state.adminSummaryReports
  },
  getAdminReportsFilters(state) {
    return state.adminReportsFilters
  },
  getExportData(state) {
    return state.exportData
  },
  getGraphData(state) {
    return state.graphData
  },
  getUserAccountCompanyInfo(state) {
    return state.userAccountCompanyDetails
  },
}

// actions
const actions = {}

// mutations
const mutations = {
  SET_ADMIN_SUMMARY_REPORTS(state, data) {
    state.adminSummaryReports = data;
  },
  SET_ADMIN_REPORTS_FILTERS(state, data) {
    state.adminReportsFilters = data;
  },
  SET_EXPORT_DATA(state, data) {
    state.exportData = data;
  },
  SET_GRAPH_DATA(state, data) {
    state.graphData = data;
  },
  SET_USER_ACCOUNT_COMPANY_INFO(state, data) {
    state.userAccountCompanyDetails = data;
  }
}

export default {
  namespaced: true,
  state: state(),
  getters,
  actions,
  mutations
}